import React, { CSSProperties } from "react";
import { getUrlWithSearchParams } from "src/services/UrlService";

interface Image {
  url: string;
  alt: string;
  copyright: string;
  dimensions: any;
}

interface ResponsiveImage extends Image {
  medium: Image;
  small: Image;
}

interface ArticlePageImageProps {
  image: ResponsiveImage;
  className?: string;
  style?: CSSProperties;
}

const ArticlePageImage = ({ image, className, style }: ArticlePageImageProps) => {
  const mainView = image;

  // Use imgix api that comes with Prismic to force resize
  const mainImgUrl = getUrlWithSearchParams(mainView?.url, {
    rect: undefined,
    fit: "max",
    w: 2000,
  });

  // Use imgix api that comes with Prismic to force resize
  const smallImgUrl = getUrlWithSearchParams(mainView?.url, {
    rect: undefined,
    fit: "max",
    w: 1000,
  });

  return (
    <picture>
      <source media="(min-width: 768px)" srcSet={mainImgUrl} />
      <source media="(max-width: 767px)" srcSet={smallImgUrl} />
      <img
        className={`${className} lazyload`}
        style={style}
        data-src={mainImgUrl}
        alt={mainView?.alt || "Untitled Image"}
      />
    </picture>
  );
};

export default ArticlePageImage;
